import { Flex, VStack } from '@chakra-ui/react'
import { useParams } from "react-router-dom";
import Block from '../components/shared/Block'
import { BsPencilSquare } from 'react-icons/bs'
import ApplicationForm from '../components/form/ApplicationForm'
import FormStepPanel from '../components/form/FormStepPanel'

const FormEdit = () => {
    const { fid } = useParams();
    return (
        <Flex p="40px" direction="column" w="full">
            <Block title="แก้ไขแบบฟอร์มคำร้องขอเข้าพักอาศัยฯ" icon={BsPencilSquare} >
                <VStack w="full">
                    <FormStepPanel step={1} />
                    <ApplicationForm fid={fid} />
                </VStack>
            </Block>
        </Flex>
    )
}

export default FormEdit